import NoInterpsMessage from './NoInterpsMessage';
export default {
  messages: [['NoInterps', NoInterpsMessage.protocol, 66]]
};